
import withStringFormValue from "./withStringFormValue";

const TextareaInput = props => {
  const { value, onChange, passthroughProps } = props;

  return (
    <textarea
      className="form-control"
      rows={2}
      value={value || ""}
      onChange={onChange}
      {...passthroughProps}
    />
  );
};

export default withStringFormValue(TextareaInput);
